//组件之间传递方法用
import Vue from 'vue'
export default new Vue
